




























































































































import {Component, Vue} from "vue-property-decorator";
import {CarInfoModel} from "@/model/car-info/car-info.model";
import {UserInfoForUpdateTmpModel} from "@/model/user-info/user-info-for-update-tmp.model";
import {UserInfoUtils} from "@/model/user-info/functions/user-info-utils";
import axios from "axios";
import {AxiosUtils} from "@/axios-utils";
import {CommonConstant} from "@/common-constant";

@Component
export default class CarInfoSelect extends Vue {
    model:UserInfoForUpdateTmpModel = new UserInfoForUpdateTmpModel;

    /** 共通ID表示名 */
    commonIdName: string = CommonConstant.COMMON_ID_NAME;

    redirectUrl:string;

    created() {
      this.redirectUrl = sessionStorage.getItem("redirectUrl");

      // 会員情報の取得
      UserInfoUtils.getUserInfo((status: number, userInfo: any) => {
        if (status == 200) {
          this.model.copy(userInfo);
        } else {
          this.$router.push("/client/error");
        }
      });

      // ヘッダ、フッタの非表示
      document.querySelector<HTMLElement>(".header").style.display = "none";
      document.querySelector<HTMLElement>(".footer").style.display = "none";
    }

    redirect() {
      sessionStorage.removeItem("redirectUrl");
      window.location.href = this.redirectUrl;
    }

    selectAndRedirect(value: CarInfoModel){
      if (this.redirectUrl) {
        let separator = this.redirectUrl.includes("?") ? "&" : "?";
        this.redirectUrl += `${separator}selectedCarId=${value.id}`;
        this.redirect();
      }
    }

    /** メッセージの表示判定 */
    isShownLogoutMessage() {
      // マイカー情報が存在、かつ、redirectUrlが指定されている場合
      return (this.model.cars.length !== 0) && sessionStorage.getItem("redirectUrl");
    }

    /** ログアウトした後、元のサービスにリダイレクトする */
    logoutAndRedirect() {
      let params = `?redirect_uri=${encodeURIComponent(sessionStorage.getItem("redirectUrl"))}`;
      axios.get(`/logoutAndRedirect${params}`).then(cb => {
        if (cb.data) {
          sessionStorage.clear();
          window.location.href = cb.data.toString();
        } else {
          // URLが指定されていない場合、エラー画面へ遷移
          this.$router.push("/client/error");
        }
      }).catch(error => AxiosUtils.gotoClientErrorPage(error, this.$router));
    }
}
